import { buildMonthRefsInclusive } from '../../../filters/utils/get-v3-month-refs';
import type { TableData } from '../types';

const YOY_PERIODS_MONTHLY = 12;
const YOY_PERIODS_WEEKLY = 52;
export const inferYoYPeriodOffsetFromDateRefs = (
  dateRefs: string[] | undefined
): number => {
  if (!dateRefs || dateRefs.length === 0) {
    return YOY_PERIODS_MONTHLY;
  }
  const first = dateRefs[0];
  return typeof first === 'string' && first.length === 10
    ? YOY_PERIODS_WEEKLY
    : YOY_PERIODS_MONTHLY;
};

export const inferYoYPeriodOffsetFromTable = (table: TableData): number =>
  inferYoYPeriodOffsetFromDateRefs(
    table.dimensionColumns.timeseries?.values.map(({ label }) => label)
  );

export const getTableMonths = (table: TableData): string[] => {
  const months = (table.dimensionColumns.timeseries?.values ?? [])
    .map(({ id }) => id)
    .sort();
  const first = months[0];
  const last = months[months.length - 1];
  return first && last ? buildMonthRefsInclusive(first, last) : [];
};

export const getYoYGrowthAt = ({
  values,
  index,
  periodOffset,
}: {
  values: number[];
  index: number;
  periodOffset: number;
}): number | null => {
  if (index < periodOffset) return null;
  const current = values[index];
  const yearAgo = values[index - periodOffset];
  if (current && yearAgo) {
    return (current - yearAgo) / yearAgo;
  }
  return null;
};

export const getLatestYoYGrowth = ({
  values,
  periodOffset,
}: {
  values: number[];
  periodOffset: number;
}): number | null => {
  const minLen = periodOffset + 1;
  if (values.length < minLen) return null;
  const current = values[values.length - 1];
  const yearAgo = values[values.length - 1 - periodOffset];
  if (current && yearAgo) {
    return (current - yearAgo) / yearAgo;
  }
  return null;
};
